<template>
  <div
    v-if="hasErrors"
    class="inline-errors__wrapper text-red-600"
  >
    <small
      v-for="(error, index) in errors"
      :key="index"
      class="block mt-1"
    >{{ error }}</small>
  </div>
</template>

<script>

export default {
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
  },
};

</script>
